import type { Viewer } from '../../../../viewer';
import { ChamferCommandAdapter } from '../../../command/chamfer/ChamferCommandAdapter';
import type { ChamferFeatureDefinitionModel } from '../../../definition/chamfer/ChamferFeatureDefinition';
import type { FeatureEditSession } from '../../../edit/FeatureEditSession';
import type { ChamferFeaturePrototype } from '../../../prototype/chamfer/ChamferFeaturePrototype';
import type { FeatureExecutionRuntime } from '../../FeatureExecutionRuntime';
import { FeatureCommitExecution } from '../FeatureCommitExecution';

/**
 * 倒角特征正式提交执行器。
 */
export class ChamferCommitExecution extends FeatureCommitExecution<
    ChamferFeatureDefinitionModel,
    ChamferFeaturePrototype
> {
    /** 执行运行时。 */
    private readonly runtime: FeatureExecutionRuntime;
    /** 替换命令通道。 */
    private readonly replaceFeatureCommand: (featureId: string, command: CadCommand) => Promise<boolean>;
    /** 命令适配器。 */
    private readonly adapter: ChamferCommandAdapter;

    /**
     * @param _viewer Viewer 实例。
     * @param runtime 执行运行时。
     * @param replaceFeatureCommand 替换命令回调。
     */
    public constructor(
        _viewer: Viewer,
        runtime: FeatureExecutionRuntime,
        replaceFeatureCommand: (featureId: string, command: CadCommand) => Promise<boolean>,
    ) {
        super();
        this.runtime = runtime;
        this.replaceFeatureCommand = replaceFeatureCommand;
        this.adapter = new ChamferCommandAdapter();
    }

    /**
     * @inheritdoc
     */
    public async commitCreate(prototype: ChamferFeaturePrototype): Promise<string> {
        const command = this.adapter.createCommandFromPrototype({
            prototype,
            clientId: 'web-client',
        }) as CadCommand;
        const result = await this.runtime.executeCommand(command);
        return result.objectId;
    }

    /**
     * @inheritdoc
     */
    public async commitEdit(
        session: FeatureEditSession<ChamferFeatureDefinitionModel, ChamferFeaturePrototype>,
        prototype: ChamferFeaturePrototype,
    ): Promise<boolean> {
        const command = this.adapter.createCommandFromPrototype({
            prototype,
            clientId: 'web-client',
        }) as CadCommand;
        return this.replaceFeatureCommand(session.getPrototype().getFeatureId(), command);
    }
}
